const noop = (): void => {
    // intentionally left blank
};

export { noop };
